import React, { Component } from 'react';
import UserComponent from './UserComponent';
import UserScoreShared from './UserScoreShared';

function DualUserComponent(props) {
    return <div className="dual-users">
        <div className="user-a"><div className="title">User A</div><UserComponent communities={props.communities1} /></div>
        <div className="user-b"><div className="title">User B</div><UserComponent communities={props.communities2} /></div>
    </div>;
}

class WelcomeScreen extends Component {
    constructor(props) {
        super(props);
        this.state = { name: props.name };
    }
    render() {
        let showValidation = this.props.showValidation;
        
        return <div className="welcome">
            <p>In this quiz, you will be presented with a list of communities (subreddits) someone is a part of. The bar shows what percentage of their activity is in this community.</p>
            <div className="user-example"><UserComponent communities={"gaming:5;funny:2"} /></div>
            <p>
                At each step, you will be shown two users. Click the button below the user which 
                is <b>more of a specialist.</b> A specialist is <b>someone whose interests focus on a particular topic</b>.
                
                You can see how many you got right after answering {showValidation ? "11" : "10"} questions.
            </p>
            <p className="name-entry">
                <input
                    onKeyUp={(e) => {
                        if (e.which == 13) {
                            this.props.onBegin(this.state.name);
                        }
                    }}
                    type="text"
                    placeholder="Optional: name for leaderboard"
                    value={this.state.name}
                    onChange={(e) => this.setState({ name: e.target.value })} />
                <span className="btn btn-primary" onClick={() => this.props.onBegin(this.state.name)}>Next Step</span>
            </p>
            <p>Thank you for your participation! Your responses help us research how users specialize on social media.</p>
        </div>;
    }
}

class ScoringComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedScore: null
        };
    }

    render() {
        let question = this.props.question;

        let preview = this.props.preview;
        let result = (score) => () => this.setState({ selectedScore: score });
        let selected = this.state.selectedScore;

        var submit = <p><span className="btn btn-primary" onClick={() => this.props.onResponse(this.state.selectedScore)}>Submit</span></p>;
        if (selected == null) {
            submit = <p><span className="btn btn-disabled">Submit</span></p>;
        }

        return <div>
            <div className="dual-scoring">
                <div className={"user-a " + (selected == "A" ? "active" : "")} onClick={result("A")}>
                    <div className="choice"><i className={"far " + (selected == "A" ? "fa-check-square" : "fa-square")}></i>User A is more specialist</div>
                </div>
                <div className={"user-b " + (selected == "B" ? "active" : "")} onClick={result("B")}>
                    <div className="choice"><i className={"far " + (selected == "B" ? "fa-check-square" : "fa-square")}></i>User B is more specialist</div>
                </div>
            </div>
            {preview ? null : submit }
        </div>;
    }
}

class QuestionScreen extends Component {
    render() {
        let question = this.props.question;

        return <div className="question">
            <p>Which of these two users is <b>more specialist</b>?</p>
            <DualUserComponent communities1={question.communities_A} communities2={question.communities_B} />
            <ScoringComponent question={question} onResponse={(response) => {
                let actual = question.specialist_score_A > question.specialist_score_B ? "A" : "B";
                let correct = response == actual;

                //console.log("----");
                //console.log(question.specialist_score_A + " vs. " + question.specialist_score_B);
                //console.log("Response: " + response + "    Actual: " + actual);

                this.props.onResponse({
                    "item_id": question.item_id,
                    "dataset_sig": question.dataset_sig,
                    "user_A": question.user_A,
                    "user_B": question.user_B,
                    "communities_A": question.communities_A,
                    "communities_B": question.communities_B,
                    "specialist_score_A": question.specialist_score_A,
                    "specialist_score_B": question.specialist_score_B,
                    "entropy_score_A": question.entropy_score_A,
                    "entropy_score_B": question.entropy_score_B,
                    "response": response
                }, correct ? 1 : 0);
            }} />
        </div>;
    }
}

function calculatePoints(responses) {
    let correct = 0;
    let n = responses.length;
    for (var i = 0; i < n; i += 1) {
        let response = responses[i];
        let actual = response.specialist_score_A > response.specialist_score_B ? "A" : "B";
        if (actual == response.response) {
            correct += 1;
        }
    }
    return correct;
}

class CompletionScreen extends Component {
    render() {
        let responses = this.props.responses;
        let correct = calculatePoints(responses);

        return <div>
            <div className="completion">
                <p><strong><i className="fas fa-check"></i> You got {correct} / {responses.length} correct!</strong></p>
            </div>
            <p>If you'd like to play again and help us collect more data, we've loaded some more questions below:</p>
            <hr />
        </div>;
    }
}

export default class UserScoreDualQuiz {
    constructor(dataset, browserId) {
        this.dataset = dataset;
        this.browserId = browserId;
    }

    welcomeComponent() {
        return WelcomeScreen;
    }

    loadQuizData(addValidation, callback) {
        let n = 10;

        UserScoreShared.loadUserScores(this.dataset, n, (results) => {
            // Add validation question
            if (addValidation) {
                results.unshift({
                    item_id: "validation",
                    communities_A: "Dogtraining:1;puppy101:2;puppies:1;lookatmydog:1",
                    communities_B: "nba:1;sailing:2;comicbooks:1;Curling:1",
                    specialist_score_A: 1,
                    specialist_score_B: 0
                });
            }
            
            callback(results);
        });
    }

    questionComponent() {
        return QuestionScreen;
    }

    completionComponent() {
        return CompletionScreen;
    }
    
    submitResponses(name, responses, points, callback) {
        UserScoreShared.submitResponses(this.dataset, name, responses, points, (scoreData) => {
            callback(scoreData);
        });
    }

    loadLeaderboard(callback) {
        UserScoreShared.loadLeaderboard(this.browserId, (leaderboard) => {
            callback(leaderboard);
        });
    }
}


// WEBPACK FOOTER //
// ./src/UserScoreDualQuiz.js